<template>
  <div>
    <b-row class="d-flex align-items-center">
      <b-col>
        <b-spinner class="float-right"></b-spinner>
      </b-col>
      <b-col class="float-left" cols="10">
        <h1>Please wait...</h1>
        <h3>This page is loading...</h3>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
